<template>
  <div>
    <LoadingSpinner />
    <router-view />
  </div>
</template>
<script>
import LoadingSpinner from "@/component/ui/LoadingSpinner.vue";

export default {
  components: { LoadingSpinner },
};
</script>



